<template>
  <div id="masterdata">
    <div class="header flex-between">
      <div class="header-text">
        <h1>礼品主数据定义</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="el-icon-search"
          @click="Searchbtn"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="el-icon-circle-plus-outline"
          @click="goToGiftDataCreation"
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.copy"
          icon="el-icon-circle-plus-outline"
          @click="ModifyCopy"
          >复制</el-button
        >
        <el-button
          v-if="jurisdiction.enable"
          icon="el-icon-circle-plus-outline"
          @click="enablethebtn"
          >启用/禁用</el-button
        >
        <el-button
          v-if="jurisdiction.synchronizationn"
          icon="el-icon-circle-plus-outline"
          @click="Synchronization"
          >同步</el-button
        >
        <el-button
          v-if="jurisdiction.modify"
          icon="el-icon-edit-outline"
          @click="ModifyCreate"
          >修改</el-button
        >
        <el-button
          v-if="jurisdiction.delete"
          icon="el-icon-delete"
          @click="Deledebtn"
          >删除</el-button
        >
        <el-button
          v-if="jurisdiction.look"
          icon="iconfont icon-chakan1"
          @click="goToGiftDataViewing"
          >查看</el-button
        >
        <el-button
          v-if="jurisdiction.templatedownload"
          icon="iconfont icon-chakan1"
          @click="Xiazaimukuai"
          >模板下载</el-button
        >
        <el-button
          v-if="jurisdiction.import"
          icon="iconfont icon-chakan1"
          @click="MemberFreezeImport = true"
          >导入</el-button
        >
        <el-button
          v-if="jurisdiction.import"
          icon="el-icon-download"
          @click="(downloadShow = true), getDownladList()"
          >下载导入结果</el-button
        >
      </div>
    </div>
    <!-- 同步提示框 -->
    <div class="Enabledisable">
      <el-dialog
        width="20%"
        title="同步提示框"
        :visible.sync="EnabledisableFormVisible"
        :close-on-click-modal="false"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">同步</span>此礼品?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Enabledisableqd">确 定</el-button>
          <el-button @click="EnabledisableFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="no-card">
      <el-card shadow="never">
        <div class="searchform">
          <el-form label-width="100px" size="mini">
            <el-row :gutter="50">
              <el-col :span="8">
                <el-form-item label="礼品编号">
                  <el-input v-model="reserveGIft.giftNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="礼品类型">
                  <el-select v-model="reserveGIft.giftKind" style="width: 100%">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="成衣" value="0"></el-option>
                    <el-option label="鞋履" value="1"></el-option>
                    <el-option label="配饰" value="2"></el-option>
                    <el-option label="非公司商品" value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="礼品名称">
                  <el-input
                    type="text"
                    v-model="reserveGIft.giftName"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="50">
              <el-col :span="8">
                <el-form-item label="创建日期从">
                  <el-date-picker
                    v-model="reserveGIft.createStartDay"
                    type="date"
                    placeholder="选择日期"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="至">
                  <el-date-picker
                    v-model="reserveGIft.createEndDay"
                    type="date"
                    placeholder="选择日期"
                    style="width: 100%"
                    value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8"> </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
    <div class="centercard">
      <el-card shadow="never">
        <el-table
          size="small"
          class="table-style"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            'text-align': 'center',
            color: '#6C6839',
            fontSize: '14px',
          }"
          :cell-style="{ 'text-align': 'center' }"
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          v-loading="loading"
          v-el-table-infinite-scroll="load"
          infinite-scroll-disabled="onLoading"
        >
          <el-table-column width="40">
            <template slot-scope="scope">
              <el-radio
                v-model="radio"
                :label="scope.$index"
                @change.native="handleRadioChange(scope.row)"
                >&nbsp;
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="giftNo" label="礼品编号"> </el-table-column>
          <el-table-column prop="giftName" label="礼品名称">
            <template slot-scope="scope">
              <div
                v-if="jurisdiction.modify"
                style="text-decoration: underline; color: #76734f"
                @click="handleGoods(scope.row)"
              >
                {{ scope.row.giftName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="giftKind" label="礼品类型">
            <template slot-scope="scope">
              {{
                scope.row.giftKind == 0
                  ? "成衣"
                  : scope.row.giftKind == 1
                  ? "革履 "
                  : scope.row.giftKind == 2
                  ? "配饰"
                  : scope.row.giftKind == 3
                  ? "非公司商品"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              {{
                scope.row.state == 0
                  ? "已启用"
                  : scope.row.state == 1
                  ? "未启用"
                  : scope.row.state == 2
                  ? "无效"
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column prop="createUserName" label="创建人">
          </el-table-column>
          <el-table-column prop="createTimeStr" label="创建日期">
            <template slot-scope="scope">
              {{ scope.row.createTimeStr | dateFormats }}
            </template>
          </el-table-column>
          <el-table-column prop="updateUserName" label="最后修改人">
          </el-table-column>
          <el-table-column prop="updateTimeStr" label="最后修改日期">
            <template slot-scope="scope">
              <div v-if="scope.row.updateTimeStr !== null">
                {{ scope.row.updateTimeStr | dateFormats }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-alert
          v-if="isMore"
          title="没有更多数据了!"
          type="warning"
          center
          :closable="false"
        >
        </el-alert>
      </el-card>
    </div>
    <!-- 导入保存确认对话框 -->
    <div class="import">
      <el-dialog
        title="积分商城—礼品主数据-导入"
        :visible.sync="MemberFreezeImport"
        :close-on-click-modal="false"
        width="40%"
      >
        <el-form
          size="mini"
          label-width="225px"
          ref="newUploadForm"
          enctype="multipart/form-data"
        >
          <el-form-item label="选择礼品主数据文件">
            <div class="flex-start">
              <el-input
                style="width: 300px"
                v-model="filename"
                :readonly="true"
                placeholder="请选择文件名"
              >
              </el-input>
              <el-upload
                class="upload"
                action="#"
                :show-file-list="false"
                :on-change="handleExcel"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :auto-upload="false"
              >
                <el-button style="margin-left: 20px">选择文件</el-button>
              </el-upload>
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 会员消费等级—会员消费等级调整-导入下载弹窗
      <div class="import">
        <el-dialog title="会员消费等级—会员消费等级调整-导入"
                   :visible.sync="defaultisderived"
                   :close-on-click-modal="false"
                   width="40%">
          <div class="resui">
            <span>成功处理行数: {{ succeedInfo.sucNum }}</span>
            <span>失败处理行数: {{ succeedInfo.errNum }}</span>
            <span>处理结果文件:
              <a :href="succeedInfo.fileUrl">{{ succeedInfo.fileUrl }} </a>
              <el-button icon="el-icon-download"
                         @click="downfile(succeedInfo.fileUrl)"
                         style="margin-left: 10px">下载</el-button>
            </span>
          </div>
        </el-dialog>
      </div> -->
    </div>
    <!-- 下载弹窗 -->
    <el-dialog
      append-to-body
      width="50%"
      :visible.sync="downloadShow"
      title="下载导入结果"
    >
      <el-table
        size="small"
        class="table-style"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          'text-align': 'center',
          color: '#6C6839',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="downloadData"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <!-- v-loading="loading"
        v-el-table-infinite-scroll="load"
        infinite-scroll-disabled="onLoading" -->
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column
          prop="startTime"
          label="导入开始时间"
        ></el-table-column>

        <el-table-column prop="endTime" label="导入结束时间"></el-table-column>

        <el-table-column prop="isComplate" label="状态">
          <template slot-scope="scope">
            {{ scope.row.isComplate ? "完成" : "执行中" }}
          </template>
        </el-table-column>
        <el-table-column prop="startTime" label="下载">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-download"
              v-if="scope.row.isComplate"
              @click="download(scope.row.downloadUrl)"
              >下载</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadShow = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  reserveGIftApi,
  reserveGIfSeetdelete,
  reserveGIfSeetenable,
  reserveGIfSeetSku,
  lntegralquerydaoru,
} from "@/api/Integralquery";
import { TApiLogsyncProcess } from "@/api/couponsDepot.js";
import { reportFormList } from "@/api/reportForm";
export default {
  name: "centre",
  data() {
    return {
      EnabledisableFormVisible: false,
      downloadData: [],
      downloadShow: false,
      jurisdiction: {
        search: false,
        create: false,
        copy: false,
        enable: false,
        modify: false,
        delete: false,
        look: false,
        templatedownload: false,
        import: false,
        synchronizationn: false,
      },
      copyCreatewes: false,
      // defaultisderived: false,
      MemberFreezeImport: false,
      filename: "",
      succeedInfo: {},
      createviewes: false,
      loading: false,
      radio: "",
      labelPosition: "right",
      labelPosition2: "top",
      createviewesbcak: false,
      handleRadioValue: [],
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      form: {
        name: "",
      },
      tableData: [],
      //列表查询
      reserveGIft: {
        pageNo: 1,
        pageSize: 40,
        createEndDay: "", //结束日期
        createStartDay: "", //开始时期
        giftKind: "", //礼物类型
        giftName: "", //礼物名称
        giftNo: "", //礼品编码
      },
      pages: 0,
      yarnse: {
        colorName: "",
        sizeName: "",
      },
      // tableList: {
      //   giftName: "", //礼品名称
      //   giftUnit: "", //单位
      //   remark: "", //备注
      //   giftKind: "", //礼品类型
      //   giftID: "", //id
      //   //---------尺码颜色
      // },
      options: [
        {
          value: 0,
          label: "成衣",
        },
        {
          value: 1,
          label: "革履",
        },
        {
          value: 2,
          label: "配饰",
        },
        {
          value: 3,
          label: "非公司商品",
        },
      ],
      //颜色
      newApp: [],
      //尺寸
      newArr: [],
      //表格数据
      todoLister: [],
      //模糊查询接受
      restaurants: [],
      cuar: {
        pageNo: "1",
        pageSize: "100",
      },
      //尺码
      chicun: [],
      //颜色
      yarnseres: [],
      //sku
      Skulist: [{}],
      //配饰规格
      commitlist: [],
      DescartesList: [],
      forMlist: [],
      readioList: [],
      //控制状态
      Stateover: [],
      hehe: [],
      count: 1,
    };
  },
  created() {
    this.reserveGIftList();
    let MasterData = JSON.parse(localStorage.getItem("MasterData"));
    for (let i = 0; i < MasterData.length; i++) {
      if (MasterData[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (MasterData[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }
      if (MasterData[i].menuName == "复制") {
        this.jurisdiction.copy = true;
        continue;
      }
      if (MasterData[i].menuName == "启用/禁用") {
        this.jurisdiction.enable = true;
        continue;
      }
      if (MasterData[i].menuName == "同步") {
        this.jurisdiction.synchronizationn = true;
        continue;
      }
      if (MasterData[i].menuName == "修改") {
        this.jurisdiction.modify = true;
        continue;
      }
      if (MasterData[i].menuName == "删除") {
        this.jurisdiction.delete = true;
        continue;
      }
      if (MasterData[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
      if (MasterData[i].menuName == "模板下载") {
        this.jurisdiction.templatedownload = true;
        continue;
      }
      if (MasterData[i].menuName == "导入") {
        this.jurisdiction.import = true;
        continue;
      }
    }
    console.log(MasterData);
  },
  mounted() {
    reserveGIfSeetSku(this.cuar).then((res) => {
      if (res.message == "success") {
        res.data.list.forEach((item) => {
          this.restaurants.push({
            value: item.sku,
          });
        });
      }
    });
  },
  computed: {
    isMore() {
      //当起始页数等于总页数时停止加载
      return this.reserveGIft.pageNo >= this.pages;
    },
    onLoading() {
      return this.loading || this.isMore;
    },
  },
  methods: {
    Synchronization() {
      if (Object.keys(this.handleRadioValue).length <= 2) {
        this.$message({
          message: "请先选择数据,才能进行同步!",
          type: "warning",
        });
      } else {
        if (
          this.handleRadioValue.state == 0 ||
          this.handleRadioValue.state == 2
        ) {
          this.EnabledisableFormVisible = true;
        } else {
          this.$message("未启用记录不能上传!");
        }
      }
    },
    Enabledisableqd() {
      let data = require("qs").stringify({
        id: this.handleRadioValue.giftID,
        type: 4,
      });
      TApiLogsyncProcess(data).then((res) => {
        if (res.success == true) {
          this.$message.success("同步成功!");
          this.EnabledisableFormVisible = false;
          this.radio = "";
          this.tableData = [];
          this.reserveGIftList();
        }else {
          this.$message.error("同步失败!")
        }
      });
    },
    //获取下载列表数据
    getDownladList() {
      reportFormList({
        groupName: "礼品主数据导入",
      }).then((response) => {
        console.log(response);
        this.downloadData = response.data;
      });
    },
    download(src) {
      this.exportShow = false;
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = process.env.VUE_APP_BASE_API + src;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    goToGiftDataCreation() {
      this.$router.push("/GiftDataCreation");
    },
    goToGiftDataViewing() {
      if (this.handleRadioValue == "") {
        return this.$message.warning("请选择要查看的数据!");
      }

      this.$router.push({
        path: "/GiftDataViewing",
        query: {
          id: this.handleRadioValue.giftID,
        },
      });
    },
    //tab表格数据
    async reserveGIftList() {
      await reserveGIftApi(this.reserveGIft).then((res) => {
        if (res.message === "success") {
          this.tableData = res.data.list;
          this.pages = res.data.pages;
          this.loading = false;
        }
      });
    },
    //radio赋值
    handleRadioChange(val) {
      //  是表格单选选中的值
      this.handleRadioValue = val;
      // this.tableList = val;
    },
    //查询功能
    Searchbtn() {
      this.radio = "";
      this.reserveGIftList();
    },
    //中心表格数据滚动
    load() {
      this.loading = true;
      setTimeout(() => {
        this.reserveGIft.pageSize += 10; //页面数据每次10
        this.reserveGIftList(); //调用接口，此时页面数据+50，获取下一次50数据
        this.loading = false;
      }, 1000);
    },
    //删除功能
    Deledebtn() {
      if (Object.keys(this.handleRadioValue).length <= 2) {
        this.$message.warning("请选择要删除的数据");
        return false;
      }
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          reserveGIfSeetdelete({ giftID: this.handleRadioValue.giftID }).then(
            (res) => {
              if (res.success) {
                this.$message.success("删除成功");
                this.radio = "";
                this.tableData = [];
                this.reserveGIftList();
              } else {
                this.$message.error(res.message);
              }
            }
          );
        })
        .catch(() => {
          this.$message.info("撤销删除");
        });
    },
    //启用禁用功能
    enablethebtn() {
      if (Object.keys(this.handleRadioValue).length <= 2) {
        this.$message.warning("请选中的数据!");
        return false;
      }
      let state = 1;
      if (this.handleRadioValue.state == 0) {
        state = 2;
      } else {
        state = 0;
      }
      this.$confirm("是否操作启用禁用？", "提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
      })
        .then(() => {
          reserveGIfSeetenable({
            giftID: this.handleRadioValue.giftID,
            state: state,
          }).then((res) => {
            if (res.success) {
              this.$message.success("操作成功");
              this.radio = "";
              this.tableData = [];
              this.reserveGIftList();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message.info("撤销删除");
        });
    },
    //修改功能
    ModifyCreate() {
      if (this.handleRadioValue == "") {
        return this.$message.warning("请选择修改的数据！");
      }
      this.$router.push({
        path: "/giftdataviewxg",
        query: {
          x: this.handleRadioValue.giftID,
        },
      });
    },
    //模板下载
    Xiazaimukuai() {
      const ele = document.createElement("a");
      ele.style.display = "none";
      // 设置href属性为文件路径，download属性可以设置文件名称
      ele.href =
        process.env.VUE_APP_BASE_API + "/api/templates/礼品主数据导入模板.xlsx";
      ele.download = "";
      // 将a标签添加到页面并模拟点击
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      // 移除a标签
      ele.remove();
    },
    //导入功能
    handleExcel(file) {
      // console.log(file);
      let formData = new FormData(); //声明一个FormDate对象
      formData.append("file", file.raw); //把文件信息放入对象中
      // console.log(formData.get("file"));
      //调用后台导入的接口
      lntegralquerydaoru(formData)
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            // 导入表格之后可以获取导入的数据渲染到页面，此处的方法是获取导入的数据
          } else {
            this.$message.success("导入成功请在下载列表查看");
            // this.defaultisderived = true;
            // this.succeedInfo = res.data;
            this.MemberFreezeImport = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "导入失败",
          });
        });
    },
    // downfile (url) {
    //   // console.log(url, '*****');
    //   const ele = document.createElement("a");
    //   ele.style.display = "none";
    //   // 设置href属性为文件路径，download属性可以设置文件名称
    //   ele.href = "https://gftest.redstone.com.cn/" + url;
    //   ele.download = "";
    //   // 将a标签添加到页面并模拟点击
    //   document.querySelectorAll("body")[0].appendChild(ele);
    //   ele.click();
    //   // 移除a标签
    //   ele.remove();
    // },
    ModifyCopy() {
      if (this.handleRadioValue == "") {
        return this.$message.warning("请选择复制的数据！");
      }
      this.$router.push({
        path: "/copygiftdataviewxg",
        query: {
          x: this.handleRadioValue.giftID,
        },
      });
    },
    //点击礼品名称
    async handleGoods(row) {
      this.$router.push({
        path: "/GiftDataViewing",
        query: {
          id: row.giftID,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__footer {
  height: 60px;
  background-color: #f2f2f2;
}
#masterdata {
  height: 100%;
}
.header {
  .header-text {
    height: 50px;
    margin-top: 20px;
    color: #76734f;
  }
}
.searchform {
  margin-top: 20px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
// input框的背景色和取消圆角

/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }
  .create,
  .amend,
  .look {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 0 50px 30px 50px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2 !important;
    }
    .el-table {
      .el-input--small .el-input__inner {
        border: 0 !important;
        text-align: center;
      }
    }
  }
  .resui {
    display: flex;
    flex-direction: column;
  }
  .resui span {
    line-height: 30px;
    font-size: 18px;
  }
  .import {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 10px 30px 20px 30px;
    }
    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }

    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
/deep/.Enabledisable {
  .el-dialog__header,
  .el-message-box__header {
    border-top-left-radius: 9px;
    border-top-right-radius: 9px;
    height: 44px;
    background: #f3f1dd;
    width: 100%;
    text-align: center;
    color: #666;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .el-dialog__title,
  .el-message-box__title {
    color: #6c6937;
    font-weight: 700;
    font-size: 16px !important;
  }
  .el-dialog .el-dialog__body {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .coverage-release .el-dialog__body {
    padding: 20px;
  }
  .el-button:hover {
    background-color: #b6b388;
  }
  .el-dialog__body {
    padding: 30px 60px;
  }
  .el-tabs__item {
    border: 1px solid #d9d9d9;
    background-color: #fff;
    color: #6c6937;
  }
  .el-dialog__footer {
    height: 60px;
    text-align: center;
    background-color: #f2f2f2;
  }

  .el-tabs__item.is-active {
    color: #6c6937;
    background-color: #f3f1dd;
  }
  .el-form-item__content {
    line-height: 0px;
  }
  .el-textarea__inner {
    // 取消拉伸样式
    resize: none;
  }
}
</style>
